import { useShipperCargoCreatePageProps } from "./fetch";
import { ShipperCargoCreatePageUi } from "./ui";

export const ShipperCargoCreatePage: React.FC = () => {
  const props = useShipperCargoCreatePageProps();
  return <ShipperCargoCreatePageUi {...props} />;
};
